module.exports = {"list":[{"feeName":"Sales Tax (9.5%)","feeNameFrench":"Saxe de vente (9.5%)","feeNameLong":"Sales Tax (9.5%)","feeNameLongFrench":"Taxe de vente (9.5%)","percentage":9.5}]}


//////////////////
// WEBPACK FOOTER
// ./view/components/create-event/helper/event-profile-request/event-fee-details/data/taxes.data.usd.json
// module id = 1454
// module chunks = 0